<template>
  <div class="Teacher">
    <div class="content"
         :style="{'height':`calc(100vh - ${octopus.passport.bangs ? '64px' : '50px'} - 90px)`}">
      <div class="content-box">
        <div class="te msg-box" @click="octopus.router.jump('/APP/Campus/MessageCenter/Page?activeID=2')">
          <div class="tit">学校通知
            <div class="sign">{{SchoolMsg.ReadNumber}}已读</div>
          </div>
          <div class="txt van-multi-ellipsis--l2">{{SchoolMsg.Content}}</div>
        </div>
        <div class="msg-box" @click="octopus.router.jump('/APP/Campus/MessageCenter/Page?activeID=1')">
          <div class="tit">班级通知
            <div class="sign">{{ClassMsg.ReadNumber}}已读</div>
          </div>
          <div class="txt van-multi-ellipsis--l2">{{ClassMsg.Content}}</div>
        </div>
      </div>
      <div class="content-box">
        <div class="equipment">
          <div class="tit">
            <div class="icon iconguzhangbaoxiu2"></div>
            设备统计
          </div>
          <div class="equipment-r">
            <div class="lend">佩戴</div>
            {{WearMsg.WearNumber}}
            <div class="lend2">未佩戴</div>
            {{WearMsg.NotToWearNumber}}
          </div>
        </div>
      </div>
      <div class="content-box" v-if="false">
        <div class="tit">
          <div class="icon iconkaoqinguanli"></div>
          今日考勤统计
        </div>
        <div class="cont">
          <div class="item">
            <div class="item-t">{{WearMsg.WearNumber+WearMsg.NotToWearNumber}}</div>
            <div class="item-b">学生总数</div>
          </div>
          <div class="item">
            <div class="item-t">{{WearMsg.WearNumber+WearMsg.NotToWearNumber}}</div>
            <div class="item-b">实到人数</div>
          </div>
          <div class="item">
            <div class="item-t item-t-te">0</div>
            <div class="item-b">病假学生</div>
          </div>
          <div class="item item-te">
            <div class="item-t item-t-te">0</div>
            <div class="item-b">事假学生</div>
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="tit">
          <div class="icon iconjiankangzhuangkuang"></div>
          今日学生健康<span></span></div>
        <div class="box-t">
          <div class="item">
            <div class="txt">{{healthyMsg.PressureOvertopNumber || 0}}</div>
            <div class="tit">压力超标人数</div>
          </div>
          <div class="item">
            <div class="txt" style="color: #3AAAF6">{{healthyMsg.SleepNumber || 0}}</div>
            <div class="tit">睡眠异常人数</div>
          </div>
          <div class="item">
            <div class="txt" style="color: #FF9702">{{healthyMsg.SportsStandardsNumber || 0}}<span></span></div>
            <div class="tit">运动达标人数</div>
          </div>
        </div>
        <div class="item-box">
          <div class="item" v-for="(item,index) in healthyList" :key="index">
            <div class="name">{{item.tit}}<span>{{item.name}}</span></div>
            <div class="txt">{{item.txt}}<span>{{item.txt2}}</span><span class="span-te">{{item.txt3}}</span></div>
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="tit">
          <div class="icon iconjiance"></div>
          睡眠与运动
        </div>
        <div class="chart">
          <div class="con" id="completionRate"></div>
          <div class="con" id="excellentRate"></div>
        </div>
      </div>
    </div>
    <div class="footPanel" v-if="octopus.passport.campus">
      <van-action-sheet v-model="minPanel" duration="0.2" class="minPanel" :overlay="false" round="true"
                        :class="octopus.passport.bangs ? 'minBangs' : ''">
        <div class="arrow" @click="showTeacherInfoPanel(1)">
          <div class="icon iconjiantouxiangshang-01 a1"></div>
          <div class="icon iconjiantouxiangshang-01 a2"></div>
        </div>
        <div class="personal">
          <div class="photo"
               v-bind:style="{backgroundImage: 'url('+ octopus.passport.campus.teacher.teacherPhoto +')'}"></div>
          <div class="body">
            <span class="name">{{octopus.passport.campus.teacher.teacherName}}</span>
            <span class="class">{{octopus.passport.campus.teacher.className}}</span>
          </div>
          <div class="icon iconweb-icon-" v-on:click="chooseClass"></div>
        </div>
        <div class="sensor">
          <div class="code">设备号：{{teacherInfo.SensorCode}}</div>
          <div class="electric">
            <span v-bind:class="'icon '+ teacherInfo.PowerIcon"></span>
            <span class="text"><span>{{teacherInfo.Electricity}}%</span></span>
          </div>
        </div>
      </van-action-sheet>
      <van-action-sheet v-model="fullPanel" duration="0.4" class="maxPanel" :overlay="false" round="true"
                        :class="octopus.passport.bangs ? 'maxBangs' : ''">
        <div class="arrow" @click="showTeacherInfoPanel(0)">
          <div class="icon iconjiantouxiangshang-01 a1 reversal"></div>
          <div class="icon iconjiantouxiangshang-01 a2 reversal"></div>
        </div>
        <div class="personal">
          <div class="photo"
               v-bind:style="{backgroundImage: 'url('+ octopus.passport.campus.teacher.teacherPhoto +')'}"></div>
          <div class="body">
            <span class="name">{{octopus.passport.campus.teacher.teacherName}}</span>
            <span class="class">{{octopus.passport.campus.teacher.className}}</span>
          </div>
          <div class="icon iconweb-icon-" v-on:click="chooseClass"></div>
        </div>
        <div class="sensor">
          <div class="code">设备号：{{teacherInfo.SensorCode}}</div>
          <div class="electric">
            <span v-bind:class="'icon '+ teacherInfo.PowerIcon"></span>
            <span class="text"><span>{{teacherInfo.Electricity}}%</span></span>
          </div>
        </div>
        <div class="asymptomatic">
          <div class="item">
            <div class="icon iconjiankangzhongxin-20 yellow"></div>
            <div class="text">步数：</div>
            <div class="center">{{teacherInfo.Steps}}</div>
          </div>
          <div class="item">
            <div class="icon iconxinlv-01 red"></div>
            <div class="text">心率：</div>
            <div class="center">{{teacherInfo.HeartRate}}次/分钟</div>
          </div>
          <div class="item">
            <div class="icon iconxueya red"></div>
            <div class="text">血压：</div>
            <div class="center">{{teacherInfo.Systolic}}/{{teacherInfo.Diastolic}}mmHg</div>
          </div>
          <div class="item">
            <div class="icon icontiwen-01 yellow"></div>
            <div class="text">体温：</div>
            <div class="center">{{teacherInfo.Temp}}℃</div>
          </div>
          <div class="item">
            <div class="icon iconshuimian-01 blue"></div>
            <div class="text">睡眠质量：</div>
            <div class="center">{{teacherInfo.SleepStatus}}</div>
          </div>
          <div class="item" v-if="teacherInfo.IsOpenOxygen">
            <div class="icon iconziyuan2 red"></div>
            <div class="text">血氧：</div>
            <div class="center">{{teacherInfo.Oxygen}}%</div>
          </div>
        </div>
      </van-action-sheet>
    </div>
    <van-popup v-model="showChooseClass" class="choosePanel" round="true">
      <div class="title">
        <!--        <div class="time">2021-10-23</div>-->
        <div class="name">切换班级</div>
      </div>
      <div class="list">
        <!--          {{studentCheckID}}-->
        <van-radio-group v-model="classCheckID" v-on:change="setClass">
          <van-cell v-for="(item, index) in classListData" :key="item.ClassIDValue">
            <van-radio :name="item.ClassIDValue">{{item.ClassName}}</van-radio>
          </van-cell>
        </van-radio-group>
      </div>
    </van-popup>

  </div>
</template>

<script>
  let elementResizeDetectorMaker = require("element-resize-detector");
  export default {
    name: "app_en_database_item", /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
        healthyList: [
          {tit: '最高体温', name: '', txt: '--', txt2: '℃'},
          {tit: '最高心率', name: '', txt: '--', txt2: '/分'},
          {tit: '最高压力', name: '', txt: '--'},
          {tit: '最高血压', name: '', txt: '--', txt3: '/--'},
          {tit: '最差睡眠', name: '', txt: '--'},
          {tit: '运动达人', name: '', txt: '--', txt2: 'kcal'},
        ],
        minPanel: true,
        fullPanel: false,
        SchoolMsg: {}, //学校通知
        ClassMsg: {}, //班级通知
        WearMsg: {}, //佩戴数据
        healthyMsg: {}, //健康数据
        StandardMsg: {}, //达标数据
        // 教师 体能 和 定位 数据
        teacherInfo: {},
        showChooseClass: false,
        classListData: {},
        classCheckID: 0,
      }
    },
    created: function () {
      // 先加载教师信息。
      this.load();
    },
    activated: function () {
      // 先加载教师信息。
      this.load();
    },
    mounted: function () {

    },
    methods: {
      load: function () {
        // this.octopus.applet.setTitle("首页");
        this.loadClass();
      },
      // 加载老师
      loadClass: function () {
        let o = this;
        // 查询数据绑定关系
        this.octopus.request.api.post("/Octopus/Engine/List", {
            id: 362,
            // value: this.octopus.passport.project,
            pageData: {rowSize: 77},// 取最新的，1个老师最多管理77个班级。
            cellData: [
              {name: "ID"},           // 任教班主任
              {name: "Code"},         // 班主任工号
              {name: "RealName"},     // 班主任名称
              {name: "Sex"},          // 性别
              {name: "PhotoPath"},    // 头像
              {name: "ClassID"}, // 所属班级ID
              {name: "ClassIDValue"}, // 所属班级ID
              {name: "ClassName"},    // 所属班级
              {name: "ClassLevelIDValue"},    // 班级年级
              {name: "SchoolIDValue"},        // 校区ID
              {name: "SchoolName"},           // 校区名
              {name: "SensorIDValue", filterKey: ">", filterValue: 0}, // 传感器 必须要有绑定值
              {name: "TeacherID", filterKey: "=", filterValue: this.octopus.passport.id}, // 关联教师
            ],
          },
          (data) => {
            if (data.status.code === 200) {
              // alert("）））"+JSON.stringify(data.content.queryData));
              if (data.content.queryData.length > 0) {
                o.classListData = data.content.queryData;

                // 得到学生信息
                let teacherData = null;

                // 循环教师班级信息。
                $(o.classListData).each(function (index, item) {
                  // 判断是否存在
                  if (o.octopus.passport.campus && o.octopus.passport.campus.teacher && o.octopus.passport.campus.teacher.classID) {
                    if (item.ClassIDValue == o.octopus.passport.campus.teacher.classID) {
                      teacherData = item;
                    }
                  }
                });

                // 如果没有默认教师数据，则默认采用第一个。
                if (!teacherData) {
                  // 得到教师信息
                  teacherData = data.content.queryData[0];
                }

                // 设置默认为第一个班级。
                o.classCheckID = teacherData.ClassIDValue;

                // 改造passport使其具备教师相关数据
                let campus = {
                  teacher: {
                    teacherID: teacherData.ID,
                    teacherName: teacherData.RealName,              // 教师名
                    teacherPhoto: JSON.parse(teacherData.PhotoPath)[0].url,
                    sex: teacherData.Sex,                           //教师性别
                    classID: teacherData.ClassIDValue,              // 班级ID
                    className: teacherData.ClassName,               // 班级名称
                    classLevelID: teacherData.ClassLevelIDValue,    // 班级年级ID
                    schoolID: teacherData.SchoolIDValue,            // 校区ID
                    schoolName: teacherData.SchoolName,             // 校区名
                    sensorID: teacherData.SensorIDValue,            // 所属传感器
                  },
                };
                o.$set(o.octopus.passport, 'campus', campus);

                // alert(JSON.stringify(o.octopus.passport.campus));

                // 执行后续加载事件。
                o.loadData();

              } else {
                // 如果没有班级的信息，则默认置空。
                o.octopus.passport.teacher = {};
                // 跳转 教师 信息补充注册流程。
                o.octopus.router.jump("/APP/Campus/User/Teacher/Page?reg=1");
              }
            } else {
              o.octopus.tips.error(data);
            }
          }
        );
      },
      loadData: function () {
        // 单页面cdn引入echarts方法
        this.octopus.load.loadEcharts(this.eChartsMethods);
        // 加载老师数据
        this.loadTeacherInfo();
        this.getHealthyMsg();
        this.getClassMsg();
        this.getSchoolMsg();
        this.getWearMsg();
      },
      // 加载老师数据
      loadTeacherInfo: function () {
        let o = this;
        // 加载教师设备数据
        this.octopus.request.api.post("/Octopus/Engine/List", {
            id: 114,
            // value: this.octopus.passport.project,
            pageData: {rowSize: 1},// 取当前老师绑定的设备。
            cellData: [
              {name: "SensorID", filterKey: "=", filterValue: this.octopus.passport.campus.teacher.sensorID}, // 传感器 必须要有绑定值
              {name: "SensorCode"}, // 关联教师
              {name: "HealthQuality"},
              {name: "HeartRate"},      // 心率
              {name: "Systolic"},       // 收缩压
              {name: "Diastolic"},      // 舒张压
              {name: "Pressure"},       // 压力
              {name: "SleepScore"},     // 睡眠分
              {name: "SleepStatus"},    // 睡眠状态
              {name: "Steps"},          // 步数
              {name: "Temp"},           // 体温
              {name: "WearRate"},       // 佩戴率
              {name: "Longitude"},      // 经度
              {name: "Latitude"},       // 纬度
              {name: "Oxygen"},         // 血氧
              {name: "Electricity"},    // 电量
              {name: "IsOpenOxygen"},   // 是否有血氧
              {name: "LocationTime"},
            ],
            // 前台传入八爪鱼指定参数，八爪鱼会自动解析并动态替换，八爪鱼数据源中用 {#date} 表达 。
            paramData: {
              date: this.octopus.tools.date("yyyyMMdd"),   // 定义date日期
              year: this.octopus.tools.date("yyyy")
            }
          },
          (data) => {
            if (data.status.code === 200) {
              // console.log("))))" + JSON.stringify(data.content.queryData));
              if (data.content.queryData.length == 1) {
                // 绑定体能数据
                o.teacherInfo = data.content.queryData[0];

                o.teacherInfo.PowerIcon = "";
                if (o.teacherInfo.Electricity <= 25) {
                  o.teacherInfo.PowerIcon = "icondianliang1";
                } else if (o.teacherInfo.Electricity <= 50) {
                  o.teacherInfo.PowerIcon = "icondianliang2";
                } else if (o.teacherInfo.Electricity <= 75) {
                  o.teacherInfo.PowerIcon = "icondianliang3";
                } else {
                  o.teacherInfo.PowerIcon = "icondianliang4";
                }

              } else {
                o.octopus.tips.error("设备未找到，请联系管理员。");
              }
            } else {
              o.octopus.tips.error(data);
            }
          }
        );

      },
      //校园通知
      getSchoolMsg() {
        this.octopus.request.api.post("/Octopus/Engine/List", {
            id: 334,
            pageData: {rowSize: 1},
            cellData: [
              {name: "SchoolID", filterKey: "=", filterValue: this.octopus.passport.campus.teacher.SchoolID}, //班级
              {name: "Content"}, //班级
              {name: "ReadNumber"}, //舒张压
              {name: "Title"}, //舒张压
              {name: "UserID", filterKey: "=", filterValue: this.octopus.passport.id}, //舒张压
            ],
          },
          (data) => {
            if (data.status.code === 200) {
              if (data.content.queryData.length > 0) {
                this.SchoolMsg = data.content.queryData[0];
              } else {
                this.SchoolMsg = {
                  ReadNumber: "",
                  Content: ""
                };
                this.octopus.tips.error("未找到学校消息数据。");
              }
            } else {
              this.octopus.tips.error(data);
            }
          }
        )
      },
      //班级通知
      getClassMsg() {
        this.octopus.request.api.post("/Octopus/Engine/List", {
            id: 333,
            pageData: {rowSize: 1},
            cellData: [
              {name: "ClassID", filterKey: "=", filterValue: this.octopus.passport.campus.teacher.classID}, //班级
              {name: "Content"}, //班级
              {name: "ReadNumber"}, //舒张压
              {name: "Title"}, //舒张压
              {name: "UserID", filterKey: "=", filterValue: this.octopus.passport.id}, //舒张压
            ],
          },
          (data) => {
            if (data.status.code === 200) {
              if (data.content.queryData.length > 0) {
                this.ClassMsg = data.content.queryData[0];
              } else {
                this.ClassMsg = {
                  ReadNumber: "",
                  Content: ""
                };
                // this.octopus.tips.error("未找到班级消息数据。");
              }
            } else {
              this.octopus.tips.error(data);
            }
          }
        )
      },
      //佩戴数
      getWearMsg() {
        // 查询佩戴，6小时内佩戴过，视为佩戴。
        this.octopus.request.api.post("/Octopus/Engine/List", {
            id: 336,
            pageData: {rowSize: 1},
            cellData: [
              {name: "ClassID", filterKey: "=", filterValue: this.octopus.passport.campus.teacher.classID}, //班级
              {name: "NotToWearNumber"}, //班级
              {name: "WearNumber"}, //WearNumber
            ],
            paramData: {
              tableDate: this.octopus.tools.dateFormat(new Date(), 'yyyyMMdd'),
            }
          },
          (data) => {
            if (data.status.code === 200) {
              if(data.content.queryData.length > 0){
                this.WearMsg = data.content.queryData[0];
              }

            } else {
              this.octopus.tips.error(data);
            }
          }
        )
      },
      //健康数据
      getHealthyMsg() {
        let o = this;
        this.octopus.request.api.post("/Octopus/Engine/List", {
            id: 331,
            pageData: {rowSize: 1},
            cellData: [
              {name: "ClassID", filterKey: "=", filterValue: this.octopus.passport.campus.teacher.classID}, //班级
              {name: "ClassName"}, //班级
              {name: "Diastolic"}, //舒张压
              {name: "HeartRate"}, //心率
              {name: "HighBloodName"}, //血压最高人
              {name: "HighHeartName"}, //心率最高人
              {name: "HighPressureName"}, //压力最高人
              {name: "HighTempName"}, //体温最高人
              {name: "LowSleepName"}, //睡眠最差人
              {name: "Pressure"}, //压力
              {name: "PressureOvertopNumber"}, //压力超标人数
              {name: "SleepNumber"}, //睡眠异常人数
              {name: "SleepScore"}, //睡眠最差得分
              {name: "SportsChampionName"}, //运动达人
              {name: "SportsStandardsNumber"}, //运动达标人数
              {name: "Steps"}, //步数
              {name: "Systolic"}, //收缩压
              {name: "Temp"}, //体温
            ],
            paramData: {
              tableDate: this.octopus.tools.dateFormat(new Date(), 'yyyyMMdd'),
              date: this.octopus.tools.dateFormat(new Date(), 'yyyy-MM-dd'),
              year: this.octopus.tools.dateFormat(new Date(), 'yyyy'),
            }
          },
          (data) => {
            if (data.status.code === 200) {
              if (data.content.queryData.length > 0) {
                o.healthyMsg = data.content.queryData[0];
                let msg = data.content.queryData[0];
                o.healthyList = [
                  {tit: '最高体温', name: msg.HighTempName, txt: msg.Temp ? msg.Temp : '--', txt2: '℃'},
                  {tit: '最高心率', name: msg.HighHeartName, txt: msg.HeartRate ? msg.HeartRate : '--', txt2: '/分'},
                  {tit: '最高压力', name: msg.HighPressureName, txt: msg.Pressure > 0 ? msg.Pressure : 0},
                  {
                    tit: '最高血压',
                    name: msg.HighBloodName,
                    txt: msg.Systolic ? msg.Systolic : '--',
                    txt3: '/' + (msg.Diastolic ? msg.Diastolic : '--')
                  },
                  {tit: '最差睡眠', name: msg.LowSleepName, txt: msg.SleepScore},
                  {tit: '运动达人', name: msg.SportsChampionName, txt: msg.Steps, txt2: '步'},
                ];
              }

            } else {
              this.octopus.tips.error(data);
            }
          }
        )
      },
      //健康数据
      getStandardMsg() {
        this.octopus.request.api.post("/Octopus/Engine/List", {
            id: 332,
            pageData: {rowSize: 1},
            cellData: [
              {name: "ClassID", filterKey: "=", filterValue: this.octopus.passport.campus.teacher.classID}, //班级
              {name: "HeadCount"}, //总人数
              {name: "SleepStandardsNumber"}, //睡眠达标人数
              {name: "SportsStandardsNumber"}, //运动达标人数
            ],
            paramData: {
              tableDate: this.octopus.tools.dateFormat(new Date(), 'yyyyMMdd'),
              date: this.octopus.tools.dateFormat(new Date(), 'yyyy-MM-dd'),
              year: this.octopus.tools.dateFormat(new Date(), 'yyyy'),
            }
          },
          (data) => {
            if (data.status.code === 200) {
              if(data.content.queryData.length > 0){
                this.StandardMsg = data.content.queryData[0];
              }
              this.$nextTick(() => {
                this.CompletionRate();
                this.ExcellentRate();
              })
            } else {
              this.octopus.tips.error(data);
            }
          }
        )
      },
      // 切换班级
      chooseClass: function () {
        this.showChooseClass = true;
      },
      setClass: function (event) {
        // 赋值
        this.octopus.passport.campus.teacher.classID = event;

        // 重新加载班级据
        this.loadClass();

        // 关闭遮罩
        this.showChooseClass = false;
      },
      //图标方法
      eChartsMethods: function () {
        let o = this;
        o.getStandardMsg();
        let report = document.getElementById("charts-container");
        if (report) {
          let erd = elementResizeDetectorMaker();
          erd.listenTo(report, function (element) { //resize监听的函数
            o.$nextTick(function () {
              //使echarts尺寸重置
              if (o.octopus.tools.iframeRepair()) {
                setTimeout(() => {// 图表循环
                  echarts.init(document.getElementById("completionRate")).resize(); //自适应图表大小
                  echarts.init(document.getElementById("excellentRate")).resize(); //自适应图表大小
                }, 50)
              }
            })
          })
        }
      },
      // 睡眠状态
      CompletionRate() {
        let o = this;
        let msg = [
          {value: Math.round((o.StandardMsg.SleepStandardsNumber / o.StandardMsg.HeadCount) * 100), name: '优良'},
          {value: 100 - Math.round((o.StandardMsg.SleepStandardsNumber / o.StandardMsg.HeadCount) * 100), name: '不达标'},
        ];
        let report = document.getElementById("completionRate");
        if (report) {
          o.graphDay = echarts.init(report);
          let option = {
            // tooltip: {
            //   trigger: 'item',
            //   formatter: function (params) {
            //     let res = params.name + "：" + params.value + "个";
            //     return res;
            //   },
            // },
            color: ['#2F89EA', '#5DACF7'],
            legend: {
              confine: true,
              icon: 'circle',
              orient: 'vertical',
              itemWidth: 8,
              itemHeight: 8,
              textStyle: {
                fontSize: 12,
                rich: {
                  total: {
                    color: ''
                  },
                  active: {
                    color: '#FF5250',
                  },
                }
              },
              bottom: '0',
              formatter: function (name) {
                const itemValueArr = msg.filter(el => el.name == name)
                if (name == '优良') {
                  return `${name}：${itemValueArr[0].value}%`
                } else {
                  return '{total|' + name + '：}' + '{active|' + itemValueArr[0].value + '%}'
                }
              },
            },
            series: [
              {
                name: '睡眠状态',
                type: 'pie',
                center: ['50%', '40%'],
                radius: ['35%', '65%'],
                avoidLabelOverlap: false,
                label: {
                  normal: {
                    show: true,
                    position: 'center',
                    color: '#2C8CF2',
                    fontSize: 14,
                    formatter: '睡眠\n状态',
                  },
                  emphasis: {//中间文字显示
                    show: true,
                  }
                },
                labelLine: {
                  show: false, //是否显示
                },
                data: msg
              }
            ]
          };
          o.graphDay.setOption(option)
        }
      },
      // 运动状态
      ExcellentRate() {
        let o = this;
        let msg = [
          {value: Math.round((o.StandardMsg.SportsStandardsNumber / o.StandardMsg.HeadCount) * 100), name: '优良'},
          {value: 100 - Math.round((o.StandardMsg.SportsStandardsNumber / o.StandardMsg.HeadCount) * 100), name: '不达标'},
        ];
        let report = document.getElementById("excellentRate");
        if (report) {
          o.graphDay = echarts.init(report);
          let option = {
            color: ['#F6CD37', '#FD5356'],
            legend: {
              confine: true,
              icon: 'circle',
              orient: 'vertical',
              itemWidth: 8,
              itemHeight: 8,
              textStyle: {
                fontSize: 12,
                rich: {
                  total: {
                    color: ''
                  },
                  active: {
                    color: '#FF5250',
                  },
                }
              },
              bottom: '0',
              formatter: function (name) {
                const itemValueArr = msg.filter(el => el.name == name)
                if (name == '优良') {
                  return `${name}：${itemValueArr[0].value}%`
                } else {
                  return '{total|' + name + '：}' + '{active|' + itemValueArr[0].value + '%}'
                }
              },
            },
            series: [
              {
                name: '运动状态',
                type: 'pie',
                center: ['50%', '40%'],
                radius: ['35%', '65%'],
                avoidLabelOverlap: false,
                label: {
                  normal: {
                    show: true,
                    position: 'center',
                    color: '#F77827',
                    fontSize: 14,
                    formatter: '运动\n状态',
                  },
                  emphasis: {//中间文字显示
                    show: true,
                  }
                },
                labelLine: {
                  show: false, //是否显示
                },
                emphasis: {
                  show: false,
                },
                data: msg,
              }
            ]
          };
          o.graphDay.setOption(option)
        }
      },
      //底部切换
      showTeacherInfoPanel(num) {
        if (num) {
          this.minPanel = false;
          setTimeout(() => {
            this.fullPanel = true;
          }, 200)
        } else {
          this.fullPanel = false;
          setTimeout(() => {
            this.minPanel = true;
          }, 400)
        }
      },
    },
    props: ["oData"]
  }
</script>



// WEBPACK FOOTER //
// src/components/APP/Campus/Home/TeacherHome.vue